import { type AxiosResponse } from "axios";
import type { CartProps } from "shared/models/cart.models";
import type { Products } from "shared/models/products.models";

import { publicInstance } from "./axios";
import privateInstance from "./axios";
import type { ProductParams } from "./models";

export type CartResponse = {
  products: Products;
  message: string;
};

export function getCart(): Promise<AxiosResponse<CartProps>> {
  return privateInstance.get<CartProps>("cart");
}

export function deleteCart() {
  return privateInstance.delete(`cart`);
}
export function decreaseQuantity({ id }: { id: string }) {
  return privateInstance.delete(`cart/product/${id}`);
}

export function addProductToCart({ data, id }: ProductParams): Promise<AxiosResponse<CartResponse>> {
  return privateInstance.put<CartResponse>(`cart/${id}`, data);
}

export function deleteProductFromCart({ id }: { id: string }) {
  return privateInstance.delete(`cart/${id}`);
}
export type DiscountProps = {
  discountCode: string;
};
export function getDiscount(params: DiscountProps) {
  return publicInstance.post("/cart/discount", { ...params });
}
